import type { ITpoFlexBiometryData } from '@common/validation/customControls/tpoFlex/tpoFlexBiometrySchema';

export const initialData: ITpoFlexBiometryData = {
    assets: [],
    examination: null,
};
